<p-table
  *ngIf="tableService.showProductsRequired().length > 0"
  [value]="tableService.showProductsRequired()"
  [paginator]="false"
  [sortOrder]="1"
  selectionMode="single"
  showGridlines
>
  <ng-template pTemplate="header">
    <tr>
      <th>DESCRIPTION</th>
      <th>UOM</th>
      <th>QUANTITY</th>
      @for (item of quotationsColumns; track $index) {
        <th class="">
          <div class="row-between-center">
            <div class="text-center row-start-center">
              <b>{{ item.providerName | titlecase }}</b>
              @if (!item.isProviderSaved) {
                <i class="ml-2" pTooltip="Provider not saved" tooltipPosition="top">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                    <path
                      fill="#ffffff"
                      d="M15 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7zm2 16H3V5h11.2L17 7.8zm-7-7c-1.7 0-3 1.3-3 3s1.3 3 3 3s3-1.3 3-3s-1.3-3-3-3M4 6h9v4H4zm19 7h-2V7h2zm0 4h-2v-2h2z"
                    />
                  </svg>
                </i>
              }
              <span (click)="onEditQuotation(item.id)" class="pi pi-pencil ml-4 cursor-pointer"></span>
            </div>
            <div class="" *ngIf="getPurchaseOrdersRelatedToQuotation(item.id) == 0">
              <span (click)="deleteQuotation(item.id)" class="pi pi-trash cursor-pointer p-3 hover:bg-red-500 transition-all rounded-full"></span>
            </div>
          </div>
        </th>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
    @let strictEntry = getStrictEntry(item);
    <tr class="cursor-pointer">
      <td>
        @if (strictEntry.itemDisplayName) {
          <b>{{ strictEntry.itemCode }}</b> {{ localeHelperService.getLocalizedValue(strictEntry.itemDisplayName) }}
        } @else {
          {{ strictEntry.itemCode }}
        }
      </td>
      <td class="font-bold">{{ getUomLabel(item.uom) | uppercase }}</td>
      <td>{{ item.quantity }}</td>
      @for (quote of quotationsColumns; track $index) {
        <td class="text-center">
          @let quoteStrictEntry = columnItemStrict(quote.items[rowIndex]);
          @if (quoteStrictEntry) {
            <div class="col-start-center justify-center" [ngClass]="{ 'bg-green-200': quoteStrictEntry.isLowestPrice }">
              <span class="font-bold"> {{ currencyValues[quote.currency] }} {{ quoteStrictEntry.totalPrice | number: '1.2-2' }}</span>
            </div>
            <td>
              @if (quoteStrictEntry.files && quoteStrictEntry.files.length > 0) {
                <img
                  [src]="quoteStrictEntry.files[0].presignedUrl"
                  alt="img-product"
                  class="w-20 h-20 cursor-pointer"
                  (click)="openImageInNewTab(quoteStrictEntry.files[0].presignedUrl)"
                />
              }
            </td>

            <span class="text-sm text-gray-500">Total: {{ currencyValues[quote.currency] }} {{ quoteStrictEntry.totalPrice | number: '1.2-2' }}</span>
          } @else {
            <span class="text-gray-400">N/A</span>
          }
        </td>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="footer">
    <!-- Total row with taxes -->
    <tr>
      <td colspan="2" class="text-right font-bold">
        <span class="text-white px-3 py-1 rounded">Total:</span>
      </td>
      <td></td>
      @for (quote of quotationsColumns; track $index) {
        <td class="text-center">
          <div class="bg-green-200 px-3 py-1 rounded font-bold">{{ currencyValues[quote.currency] }} {{ getGrandTotal(quote) | number: '1.2-2' }}</div>
        </td>
      }
    </tr>
    <!-- Create Purchase Order row -->
    <tr>
      <td colspan="3"></td>
      @for (quote of quotationsColumns; track $index) {
        <td class="text-center">
          <div class="row-between-stretch gap-2 p-2">
            <p-button
              (onClick)="redirectToPurchaseOrder(quote)"
              label="Create Purchase Order"
              [outlined]="true"
              size="small"
              severity="success"
              [disabled]="!quote.isProviderSaved"
            />
            <p>
              <b><small>Purchase Orders</small>: </b> {{ getPurchaseOrdersRelatedToQuotation(quote.id) }}
            </p>
          </div>
        </td>
      }
    </tr>
  </ng-template>
</p-table>
